import React, { useState } from 'react';
import apiDefinitions from '../../../../core/api/apiDefinitions';
import { showError, showSuccess } from '../../../../core/alert/sweetAlertConfig';

interface CreateParkingSlotModuleProps {
  show: boolean;
  onHide: () => void;
  locationId: number | null;
  floorId: number | null;
  locationName: string;
  buildingName: string;
  floorName: string;
  onSuccess: () => void;
}

const CreateParkingSlotModule: React.FC<CreateParkingSlotModuleProps> = ({
  show,
  onHide,
  locationId,
  floorId,
  locationName,
  buildingName,
  floorName,
  onSuccess,
}) => {
  const [slotName, setSlotName] = useState<string>('');

  const handleSubmit = async () => {
    if (!slotName.trim()) {
      showError('Slot name is required');
      return;
    }
    try {
      const payload = {
        slotName,
        locationId: floorId ? null : locationId,
        floorId,
      };
      const response = await apiDefinitions.addParkingSlot(payload);
      if (response.data.status === 'S1000') {
        showSuccess("Parking slot created successfully");
        onSuccess();
        onHide();
      } else {
        showError(response.data?.statusDescription || 'Failed to create parking slot');
      }
    } catch (err: any) {
      showError(err.response?.data?.statusDescription || 'Failed to create parking slot. Please try again.');
    }
  };

  return (
    <div className={`modal ${show ? 'd-block' : ''}`} tabIndex={-1}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Create Parking Slot</h5>
            <button type="button" className="btn-close" onClick={onHide}></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label>Slot Name</label>
              <input
                type="text"
                className="form-control"
                value={slotName}
                onChange={(e) => setSlotName(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Location/Building/Floor</label>
              <input
                type="text"
                className="form-control"
                value={floorName || buildingName || locationName || '-'}
                disabled
              />
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-primary" onClick={onHide}>
              Cancel
            </button>
            <button type="button" className="btn btn-success" onClick={handleSubmit}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateParkingSlotModule;